<template>
  <div id="pdfvuer">
    <div class="columns is-centered">
      <div class="column">
        <p class="title" style="text-align: center;">
          {{ $t(documentTitle) }}
        </p>
      </div>
    </div>

    <div class="container">
      <pdf
        :src="pdfdata"
        v-for="i in numPages"
        :key="i"
        :id="i"
        :page="i"
        :scale.sync="scale"
        style="width:100%;margin:20px auto;"
      >
        <template slot="loading">
          <b-loading
            :is-full-page="true"
            :active="true"
            :can-cancel="false"
          ></b-loading>
        </template>
      </pdf>
    </div>

    <nav class="navbar is-fixed-bottom">
      <div class="navbar-brand">
        <div class="navbar-item">
          <b-field grouped group-multiline>
            <b-field class="has-addons">
              <p class="control">
                <button @click="page > 1 ? page-- : 1" class="button">
                  <b-icon pack="fas" icon="arrow-left" size="is-small"></b-icon>
                </button>
              </p>
              <p class="control">
                <span class="button is-static"
                  >{{ page }} / {{ numPages ? numPages : '∞' }}</span
                >
              </p>
              <p class="control">
                <button @click="page < numPages ? page++ : 1" class="button">
                  <b-icon
                    pack="fas"
                    icon="arrow-right"
                    size="is-small"
                  ></b-icon>
                </button>
              </p>
            </b-field>
            <b-field>
              <p class="control">
                <button @click="scale -= scale > 0.2 ? 0.1 : 0" class="button">
                  <b-icon
                    pack="fas"
                    icon="search-minus"
                    size="is-small"
                  ></b-icon>
                </button>
              </p>
              <p class="control">
                <span class="button is-static">{{ formattedZoom }} %</span>
              </p>
              <p class="control">
                <button @click="scale += scale < 2 ? 0.1 : 0" class="button">
                  <b-icon
                    pack="fas"
                    icon="search-plus"
                    size="is-small"
                  ></b-icon>
                </button>
              </p>
            </b-field>
          </b-field>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import pdfvuer from 'pdfvuer'

export default {
  components: {
    pdf: pdfvuer
  },
  props: {
    documentUrl: {
      type: String,
      required: true
    },
    documentTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width'
    }
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100)
    }
  },
  mounted() {
    this.getPdf()
  },
  watch: {
    show: function(s) {
      if (s) {
        this.getPdf()
      }
    },
    page: function(p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        document.getElementById(p).scrollIntoView()
      }
    }
  },
  methods: {
    getPdf() {
      var self = this
      self.pdfdata = pdfvuer.createLoadingTask(self.documentUrl)
      self.pdfdata.then(pdf => {
        self.numPages = pdf.numPages
        window.onscroll = function() {
          changePage()
        }

        function changePage() {
          var i = 1,
            count = Number(pdf.numPages)
          do {
            if (
              window.pageYOffset >= self.findPos(document.getElementById(i)) &&
              window.pageYOffset <= self.findPos(document.getElementById(i + 1))
            ) {
              self.page = i
            }
            i++
          } while (i < count)
          if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
            self.page = i
          }
        }
      })
    },
    findPos(obj) {
      return obj.offsetTop
    }
  }
}
</script>

<style lang="css" scoped>
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/* Page content */
.content {
  padding: 16px;
}

span.button.is-static {
    height: 50px !important;
}
</style>
